import angular, { IDirective, IScope } from 'angular';
import { IDjangoApi1ProjectLicense, IProject } from '../../tn.common';
import { daysBetween } from '../../tn.licenses/days-between.filter/days-between';
import projectStatusTemplate from './project-status.html';

interface IProjectStatusScope extends IScope {
    closestUsageVisits: number | null;
    closestExpiration: number | null;
    licensesCloseToExpiration: number | null;
    expiredLicenses: number | null;
    project: IProject;
}

export function ProjectStatus(): IDirective<IProjectStatusScope> {
    return {
        scope: {
            project: '=',
        },
        template: projectStatusTemplate,
        link: function (scope) {
            scope = angular.extend(scope, {
                closestUsageLimit: null,
                closestUsageVisits: null,
                closestExpiration: null,
                licensesCloseToExpiration: null,
                expiredLicenses: null,
            });

            scope.$watch(
                'project.licenses',
                function (licenses: IDjangoApi1ProjectLicense[]) {
                    if (!Array.isArray(licenses)) {
                        return;
                    }
                    if (
                        licenses.length > 0 &&
                        typeof licenses[0] !== 'object'
                    ) {
                        return;
                    }

                    _calculateExpirations(licenses);
                    _calculateUsageLimits(licenses);
                }
            );

            function _calculateExpirations(
                licenses: IDjangoApi1ProjectLicense[]
            ) {
                // Calculate the license closest to expiration
                const expiringLicenses = licenses.filter(
                    (license) =>
                        license.fontRights.web.end &&
                        license.fontRights.web.active
                );

                scope.expiredLicenses = expiringLicenses.filter(
                    (license) => license.fontRights.web.active === false
                ).length;

                if (expiringLicenses.length > 0) {
                    const today = new Date();

                    scope.licensesCloseToExpiration = expiringLicenses.filter(
                        (license) =>
                            daysBetween(
                                new Date(license.fontRights.web.end),
                                today
                            ) <= 30
                    ).length;

                    if (scope.licensesCloseToExpiration === 0) {
                        expiringLicenses.sort(function (a, b) {
                            return (
                                new Date(a.fontRights.web.end).getTime() -
                                new Date(b.fontRights.web.end).getTime()
                            );
                        });

                        scope.closestExpiration = daysBetween(
                            new Date(expiringLicenses[0].fontRights.web.end),
                            today
                        );
                    }
                }
            }

            function _calculateUsageLimits(
                licenses: IDjangoApi1ProjectLicense[]
            ) {
                // Calculate the license closet to usage limit
                const limitedLicenses = licenses.filter((license) => {
                    return license.fontRights.web.qty > -1;
                });

                if (limitedLicenses.length > 0) {
                    limitedLicenses.sort(function (a, b) {
                        return (
                            a.fontRights.web.qty -
                            a.fontRights.web.visits -
                            (b.fontRights.web.qty - b.fontRights.web.visits)
                        );
                    });

                    scope.closestUsageVisits =
                        limitedLicenses[0].fontRights.web.visits;
                    scope.closestUsageVisits =
                        limitedLicenses[0].fontRights.web.qty;
                }
            }
        },
    };
}
